export function data() {
  return {
    formData: {
      surveySectionID: 0,
      name: '',
      title: ''
    },
    surveyHeaderID: 0,
    isDebug: true,
    isOpen: false,
    loading: true,
    isFetching: false,
    openOnFocus: true,
    buttonText: 'Add'
  }
}
